import { useMemo } from 'react';
import { useRsi } from '../../hooks/useRsi';
export { UserEvents } from './Events/UserEvents';

export function useUserEvent() {
  const { onTrackUserEvent } = useRsi();

  return useMemo(
    () => ({
      track: onTrackUserEvent
    }),
    [onTrackUserEvent]
  );
}
